export default "__VITE_ASSET__BKBTlVqK__"